module.exports = __webpack_public_path__ + "static/media/eye.0c7b4da8.svg";